export const countEmployeesOrganizationService = (fetch) => async () => {
  try {
    const response = await fetch({
      url: '/api/v1/plan-trabajo-capacitacion/colaboradores-organizacion'
    })

    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
